import { useQueryClient } from '@tanstack/react-query';

import { useState } from 'react';

import { useUpdatePairedSalesStudy } from '../../hooks/api/schema-hooks/useUpdatePairedSalesStudy.js';
import {
  useCreatePairedSalesStudy,
  useListPairedSalesStudies,
} from '../../hooks/api/toolkitComponents.js';

export const useNewStudiesState = () => {
  const [selectedStudies, setSelectedStudies] = useState<string[]>([]);

  const queryClient = useQueryClient();

  const studies = useListPairedSalesStudies({}, { meta: { showGlobalLoader: true } });

  const createStudyReq = useCreatePairedSalesStudy({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['api', 'v2', 'pairedSales'],
      });
    },
  });

  const updateStudyReq = useUpdatePairedSalesStudy({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['api', 'v2', 'pairedSales'],
      });
    },
  });

  const api = {
    studies,
    selectedStudies,
    setSelectedStudies,
    createStudyReq,
    updateStudyReq,
  };

  return api;
};
